"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var SECOND = 1000;
var MINUTE = SECOND * 60;
var HOUR = MINUTE * 60;
var DAY = HOUR * 24;
var formatNumber = function formatNumber(num) {
  return Math.floor(num).toString();
};
var getRemainingTime = function getRemainingTime(deadline) {
  return deadline.getTime() - Date.now();
};
var timeUnitMap = {
  DAY: {
    unit: "DAY",
    fromTime: function fromTime(time) {
      return formatNumber(time / DAY);
    }
  },
  HOUR: {
    unit: "HR",
    fromTime: function fromTime(time) {
      return formatNumber(time / HOUR % 24);
    }
  },
  MINUTE: {
    unit: "MIN",
    fromTime: function fromTime(time) {
      return formatNumber(time / MINUTE % 60);
    }
  },
  SECOND: {
    unit: "SEC",
    fromTime: function fromTime(time) {
      return formatNumber(time / SECOND % 60);
    }
  }
};
var TimerDisplayBox = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var time = _ref.time,
    displayUnit = _ref.displayUnit,
    _ref$boxClass = _ref.boxClass,
    boxClass = _ref$boxClass === void 0 ? "bg-white" : _ref$boxClass;
  var _ref2 = timeUnitMap[displayUnit] || {},
    unit = _ref2.unit,
    fromTime = _ref2.fromTime;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(boxClass, " flex flex-col items-center justify-center rounded-md leading-tight"),
    style: {
      width: 40,
      height: 40,
      fontSize: 12
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-bold text-md"
  }, fromTime(time)), unit);
});
var Timer = function Timer(_ref3) {
  var _ref3$classList = _ref3.classList,
    classList = _ref3$classList === void 0 ? "" : _ref3$classList,
    boxClass = _ref3.boxClass,
    _ref3$deadline = _ref3.deadline,
    deadline = _ref3$deadline === void 0 ? new Date("2024-01-01T08:00:00.000Z") : _ref3$deadline;
  var _useState = (0, _react.useState)(getRemainingTime(deadline)),
    _useState2 = _slicedToArray(_useState, 2),
    time = _useState2[0],
    setTime = _useState2[1];
  (0, _react.useEffect)(function () {
    var interval = setInterval(function () {
      setTime(function (prevTime) {
        return prevTime - SECOND;
      });
    }, SECOND);
    return function () {
      return clearInterval(interval);
    };
  }, []);
  if (Date.now() > deadline) {
    return /*#__PURE__*/_react["default"].createElement("div", null);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "m-auto flex space-x-2 rounded-lg place-content-center ".concat(classList)
  }, Object.keys(timeUnitMap).map(function (unit) {
    return /*#__PURE__*/_react["default"].createElement(TimerDisplayBox, {
      key: "timer-".concat(unit),
      time: time,
      displayUnit: unit,
      boxClass: boxClass
    });
  }));
};
var _default = exports["default"] = Timer;